import React from 'react';
// 1. Import useNavigate along with the others
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './AdminDashbord.css'; // This will use the new professional CSS

const navItems = [
  { label: 'Dashboard', icon: 'bi-house', path: '/admin/AmanagerDashboard' },
  { label: 'Manage Managers', icon: 'bi-people', path: '/admin/manage-managers' },
  { label: 'Manage Brokers', icon: 'bi-people-fill', path: '/admin/manage-brokers' },
  { label: 'Assign Forms', icon: 'bi-file-earmark-plus', path: '/admin/AassignForm' },
  { label: "submission", icon: 'bi-file-earmark-text', path: '/admin/Asubmission' },
  { label: 'Profile', icon: 'bi-person', path: '/admin/profile' },
];

const AdminDashbord = () => {
  const location = useLocation();
  const navigate = useNavigate(); // 2. Initialize the navigate hook

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/'); // 3. Use navigate for a smooth SPA experience
  };

  return (
    <nav className="admin-dashboard-sidebar">
      {/* 4. Use Link instead of <a> for the brand to prevent page reloads */}
      <Link to="/" className="brand">
        ESTATES AT WHITE OAK
      </Link>
      <hr />
      <ul className="nav-list">
        {navItems.map((item) => (
          <li className="nav-item" key={item.label}>
            <Link
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              // 5. Add aria-current for better accessibility
              aria-current={location.pathname === item.path ? 'page' : undefined}
            >
              <i className={`bi ${item.icon}`}></i>
              <span>{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
      <div className="logout-section">
        <button type="button" className="nav-link logout-button" onClick={handleLogout}>
          <i className="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default AdminDashbord;